import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import soa from '../../img/soa.jpg'
import soascr from '../../img/soascr.jpg'
import soaFont from '../../img/soaFont.jpg'

function Soa() {
  const { t } = useTranslation();
  
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);

  return (
    <div className='container'>
      <MainTitle title={t('soaTitle')} />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('designDecisions')}</h2>
          <p><Trans i18nKey="soaDDTxt"></Trans></p>
          <figure>
            <img className='image-fluid' src={soaFont} alt="Typescale" />
            <figcaption>Soa font</figcaption>
          </figure>
          <ul className='colors'>
            <li><span className='color' style={{background: "#2E2E3F"}}></span> #2E2E3F</li>
            <li><span className='color' style={{background: "#4C4C5F"}}></span> #4C4C5F</li>
            <li><span className='color' style={{background: "#8E732E"}}></span> #8E732E</li>
            <li><span className='color' style={{background: "#B18D20"}}></span> #B18D20</li>
            <li><span className='color' style={{background: "#D6A81C"}}></span> #D6A81C</li>
            <li><span className='color' style={{background: "#49467F"}}></span> #49467F</li>
            <li><span className='color' style={{background: "#6762B8"}}></span> #6762B8</li>
            <li><span className='color' style={{background: "#F5F5F5"}}></span> #F5F5F5</li>
          </ul>

        <h2>{t('designSystem')}</h2>
        <p><Trans i18nKey="soaDSTxt"></Trans></p>

        <h2>{t('uxApproach')}</h2>
        <p><Trans i18nKey="soaUXTxt" components={{ul: <ul />, li: <li />}}>
        The main UX goal was to simplify the process of exploring and booking outdoor activities while making the browsing experience feel exciting and intuitive. The website structure was designed to guide users naturally through tour categories, activity details, and booking actions without overwhelming the interface.
        <br /><br />Special attention was given to:
        <ul>
          <li>clear tour presentation</li>
          <li>easy navigation flow</li>
          <li>strong call-to-action hierarchy</li>
          <li>readable activity information</li>
          <li>visually engaging layouts</li>
        </ul>
        The experience was designed to balance adventure-focused visuals with functional usability and accessibility.
        </Trans></p>

        <h2>{t('visualDirection')}</h2>
        <p><Trans i18nKey="soaVDTxt"></Trans></p>

        <h2>{t('figmaScr')}</h2>
        <figure>
          <img className='image-fluid' src={soascr} alt={t('figmaScr')} />
          <figcaption>{t('soaScrCaption')}</figcaption>
        </figure>

        <h2>{t('finalOutcome')}</h2>
        <p><Trans i18nKey="soaFOTxt"></Trans></p>

        <Link className="btn btn-link btn-inner mt-20" to={"https://splitoutdooradventure.com/hr/"} target="_blank">{t('seeWebpage')}</Link>
      </div>
    </div>
  )
}

export default Soa

function ContentOne() {
  return(
    <img className="image-fluid" src={soa} alt="SOA" />
  );
}

function ContentTwo() {
  const { t } = useTranslation();

  return(
    <div className='innerMain mx-50'>
      <p className='mt-0'>{t('soaMainTxt')}</p>
      <Link className="btn btn-link mt-20" to={"https://splitoutdooradventure.com/hr/"} target="_blank">{t('seeWebpage')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
      <p className='problem'><Trans i18nKey="soaMainText2">
        The main problem to solve was: <br/><i>How to make it easier for the user to find a future adventure with an emphasis on Quad trips.</i>
      </Trans></p>
    </div>
  );
}